import { FormField } from './form-field';

export class MaskTextboxField extends FormField<string> {
  override controlType = 'maskedtextbox';
  override type: string;
  override mask: string;

  constructor(options: any = {}) {
    super(options);
    this.type = options[`type`] || '';
    this.mask = options[`type`] || '999-999-9999';
  }
}